import { render } from "./DetalhesPlanos.vue?vue&type=template&id=3d4bd6fe&scoped=true"
import script from "./DetalhesPlanos.vue?vue&type=script&lang=js"
export * from "./DetalhesPlanos.vue?vue&type=script&lang=js"

import "./DetalhesPlanos.vue?vue&type=style&index=0&id=3d4bd6fe&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\comprodonto_site_v4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d4bd6fe"]])

export default __exports__